import axios from "axios";
import { Message } from "element-ui";
import router from "@/router";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || "https://admin.yyshanci.com/api",
  timeout: 15000,
});

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

service.interceptors.response.use(
  (response) => {
    const res = response.data || {};
    if (res.code === 1) {
      return res;
    }
    if (res.code == 0) {
      const msg = res.msg || "请求失败，请稍后重试";
      
      Message.error({
        message: msg,
        duration: 3000,
        showClose: true,
      });
      
      setTimeout(() => {
        const messageEl = document.querySelector(".el-message");
        if (messageEl) {
          const style = window.getComputedStyle(messageEl);
          
          if (parseFloat(style.opacity) < 0.1) {
            messageEl.style.opacity = "1";
          }
          
          messageEl.style.zIndex = "9999";
          messageEl.style.position = "fixed";
        }
      }, 10);
      return Promise.reject(res);
    }

    
    
    

    if (res.code === 404) {
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("avatar");
      localStorage.removeItem("userInfo");
      if (router.currentRoute.path !== "/login") {
        router.push("/login").catch((err) => {
          
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
      }
    }

    return Promise.reject(res);
  },
  (error) => {
    let message = "网络异常，请稍后重试";

    if (error.response) {
      
      const status = error.response.status;
      const data = error.response.data;

      if (status == 500) {
        message = data?.msg || "服务器内部错误，请稍后重试";
      } else if (status == 404) {
        message = data?.msg || "请求的资源不存在";
      } else if (status == 403) {
        message = data?.msg || "没有权限访问";
      } else if (status == 401) {
        message = data?.msg || "未授权，请重新登录";
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        localStorage.removeItem("avatar");
        localStorage.removeItem("userInfo");
        if (router.currentRoute.path !== "/login") {
          router.push("/login").catch((err) => {
            
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
        }
      } else {
        message = data?.msg || `请求失败 (${status})`;
      }
    }
    Message.error(message);
    console.error("API Error:", error);
    return Promise.reject(error);
  },
);

export default service;
